import { useQuery } from 'react-query';

import { TABLET_API_ORIGIN } from '@/global/env';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AuthStoreDeliveryAreas } from '@/pages/delivery/in-house/types';
import { AuthStoresService } from '@/services/AuthStores';

export const useDeliveryAreas = () => {
  const {
    data: authStoresDeliveryAreas,
    error: error,
    isLoading: isLoading,
  } = useQuery<AuthStoreDeliveryAreas[], Error>(
    ['authStoresDeliveryAreas'],
    () => {
      return getClient()
        .get<AuthStoreDeliveryAreas[]>(
          `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/delivery-areas` as const
        )
        .catch((error: Error) => errorHandler({ error }));
    }
  );
  const handleDeliveryAreaUpdate = async (
    authStoreDeliveryAreas: AuthStoreDeliveryAreas
  ) => {
    try {
      const params: AuthStoreDeliveryAreasParams = {
        auth_store_id: authStoreDeliveryAreas.auth_store_id,
        delivery_areas: authStoreDeliveryAreas.delivery_areas || [],
      };
      await useDeliveryAreaUpdate(params);
      alert('配達エリアを更新しました');
      window.location.reload();
    } catch (error) {
      errorHandler({ error: error as Error });
    }
  };
  return {
    authStoresDeliveryAreas: authStoresDeliveryAreas ?? [],
    isLoading,
    handleDeliveryAreaUpdate,
    error,
  };
};

export type AuthStoreDeliveryAreasParams = {
  auth_store_id: number;
  delivery_areas: AuthStoreDeliveryAreas['delivery_areas'];
};

export const useDeliveryAreaUpdate = async (
  params: AuthStoreDeliveryAreasParams
): Promise<void> => {
  const authStoresService = new AuthStoresService(getClient());
  await authStoresService.put(params);
};
